export const STATUS_RULES = {
  WAITING_FOR_PAYMENT: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: true,
      message: 'ステータスを［支払い済み］に変更します。',
      description: 'The payment has been received in the correct amount.',
    },
    AMOUNT_DISCREPANCY: {
      index: 2,
      require: 'CREDIT_CARD',
      message: 'ステータスを［金額相違あり］に変更します。',
      error: '受付済みのためこのステータスには変更できません。',
      description: 'A payment was received with an incorrect amount.',
    },
    WAITING_FOR_REGISTRATION: {
      index: 3,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Incorrect state selected.',
    },
    CANCELLATION_WAITING_LIST: {
      index: 4,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Incorrect state selected.',
    },
    ADMIN_CANCELED: {
      index: 5,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
      description: 'Received cancellation notification from unpaid user..',
    },
  },
  PAYMENT_COMPLETED: {
    WAITING_FOR_PAYMENT: {
      index: 12,
      error: '受付済みのためこのステータスには変更できません。',
      description:
        'No need to change the state.',
    },
    AMOUNT_DISCREPANCY: {
      index: 34,
      message: 'ステータスを［金額相違あり］に変更します。',
      require: 'CREDIT_CARD',
      error: '受付済みのためこのステータスには変更できません。',
      description:
        'It was later discovered that the payment amount was incorrect.',
    },
    WAITING_FOR_REGISTRATION: {
      index: 5,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Wait until the minimum quantity is reached - Not allowed',
    },
    CANCELLATION_WAITING_LIST: {
      index: 6,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Waiting for cancellation / on waiting list - Not allowed',
    },
    ADMIN_CANCELED: {
      index: 7,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
      description:
        'After payment, change to a different organization code or request a refund.',
    },
  },
  AMOUNT_DISCREPANCY: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: true,
      message: 'ステータスを［支払い済み］に変更します。',
      description: 'The payment has been received in the correct amount.',
    },
    WAITING_FOR_PAYMENT: {
      index: 2,
      allow: true,
      message: 'ステータスを［支払い待ち］に変更します。',
      description:
        'Incorrectly marked "Amount discrepancy" for users who have not yet paid (Bank Transfer/PayPal).',
    },
    WAITING_FOR_REGISTRATION: {
      index: 3,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Wait until the minimum quantity is reached - Not allowed',
    },
    CANCELLATION_WAITING_LIST: {
      index: 4,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Cancellation pending - Not allowed',
    },
    ADMIN_CANCELED: {
      index: 5,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
      description: 'Cancelled - Not allowed',
    },
  },
  WAITING_FOR_REGISTRATION: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: false,
      error:
        'ユーザーが支払いできるよう、先に［支払い待ち］に変更してください。',
      description: 'Paid - Not allowed',
    },
    WAITING_FOR_PAYMENT: {
      index: 2,
      allow: true,
      message:
        'ステータスを［支払い待ち］に変更します。\nこれによりユーザーはアプリで支払方法を選択できるようになります。',
      description:
        'Once the minimum order quantity is reached → Contact the user to proceed with payment.',
    },
    AMOUNT_DISCREPANCY: {
      index: 3,
      allow: false,
      error:
        'ユーザーが支払いできるよう、先に［支払い待ち］に変更してください。',
      description: 'Amount discrepancy - Not allowed',
    },
    CANCELLATION_WAITING_LIST: {
      index: 4,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Cancellation pending - Not allowed',
    },
    ADMIN_CANCELED: {
      index: 5,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
      description: 'Received cancellation notification from user.',
    },
  },
  CANCELLATION_WAITING_LIST: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: true,
      message:
        'ステータスを［支払い済み］に変更します。\nユーザーの支払いが完了していることを確認してこの操作を行ってください。',
      description:
        'Payment has been made to a different organization code → Office confirms request to change class schedule.',
    },
    WAITING_FOR_PAYMENT: {
      index: 2,
      allow: true,
      message:
        'ステータスを［支払い待ち］に変更します。\nこれによりユーザーはアプリで支払方法を選択できるようになります。',
      description:
        'When a slot becomes available → Contact the user to proceed with payment.',
    },
    AMOUNT_DISCREPANCY: {
      index: 3,
      allow: false,
      error:
        'ユーザーが支払いできるよう、先に［支払い待ち］に変更してください。',
      description: 'Amount discrepancy - Not allowed',
    },
    WAITING_FOR_REGISTRATION: {
      index: 4,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
      description: 'Wait until the minimum quantity is reached - Not allowed',
    },
    ADMIN_CANCELED: {
      index: 5,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
      description: 'Received cancellation notification from user.',
    },
  },
  ADMIN_CANCELED: {
    PAYMENT_COMPLETED: {
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
      description: 'Received cancellation notification from user.',
    },
    WAITING_FOR_PAYMENT: {
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
      description: 'Received cancellation notification from user.',
    },
    AMOUNT_DISCREPANCY: {
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
      description: 'Received cancellation notification from user.',
    },
    WAITING_FOR_REGISTRATION: {
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
      description: 'Received cancellation notification from user.',
    },
    CANCELLATION_WAITING_LIST: {
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
      description: 'Received cancellation notification from user.',
    },
  },
};

export const statusOptions = [
  { value: 'PAYMENT_COMPLETED', label: '支払い済み' },
  { value: 'AMOUNT_DISCREPANCY', label: '金額相違あり' },
  { value: 'WAITING_FOR_PAYMENT', label: '支払い待ち' },
  { value: 'WAITING_FOR_REGISTRATION', label: '最小催行達成待ち' },
  { value: 'CANCELLATION_WAITING_LIST', label: 'キャンセル待ち' },
  { value: 'ADMIN_CANCELED', label: 'キャンセル' },
];

export const checkStatusTransition = (
  currentStatus,
  nextStatus,
  type = null
) => {
  const rule = STATUS_RULES[currentStatus]?.[nextStatus];

  if (currentStatus === nextStatus) {
    return { allow: false, error: null };
  } else if (!rule) {
    return { allow: false, error: 'Not rules for this status' };
  } else if (rule.require) {
    if (rule.require !== type) {
      return { ...rule, allow: true };
    } else {
      return { ...rule };
    }
  }

  return { ...rule };
};
